export enum ReportType {
  spacesAvailability = 'SpacesAvailability',
}
export enum outputFormat {
  excel = 'Excel',
}
